import IconComponent from "icons/IconComponent";

import OrderIcon from "./order.svg";

export default (OrderIcon as any) as IconComponent;
